import { NomObjectClass } from './constants';
import { UserAccessLevel } from './services/user.service';

/**
 * USER_ACCESS_LEVEL a user needs for an object's Settings action. The card / cell
 * dropdown filters its Settings entry with it and a grid's title link uses the
 * same threshold (`cellRendererParams.clickAccessLevel`), so the title never
 * offers what the menu would hide. Objects missing here rely on the row's
 * OBJECT_PERMISSIONS flags (`can_view` / `can_edit`) instead.
 */
export const OBJECT_SETTINGS_ACCESS_LEVEL: Partial<
  Record<NomObjectClass, UserAccessLevel>
> = {
  [NomObjectClass.USER]: UserAccessLevel.CLIENT_ADMIN,
  // Group saves are guarded server-side by the Group Management feature within
  // the company, and the grid is company-scoped by the backend.
  [NomObjectClass.USER_GROUP]: UserAccessLevel.CLIENT_ADMIN,
  [NomObjectClass.ROLE]: UserAccessLevel.SYSTEM_ADMIN,
  // Mirrors the backend's UserAccessLevel::hasAdminAccess: a Client Admin may
  // edit their own company, Global Admin and above any company. Companies carry
  // no OBJECT_PERMISSIONS flags; the editor's tabs add their own finer gates.
  [NomObjectClass.COMPANY]: UserAccessLevel.CLIENT_ADMIN,
};
